import React from "react";
import { motion } from "motion/react";
import ReviewDisplayer from "components/ReviewDisplayer";
import FancyLine from "images/FancyLine.png";
import SuperLine from "images/Gold under.webp";
import { reviews } from "./reviews";
import "./Reviews.css";

const cardVariants = {
  hidden: { opacity: 0, y: 18 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { delay: 0.05 * i, duration: 0.45, ease: [0.22, 1, 0.36, 1] },
  }),
};

function ReviewsPage() {
  return (
    <div className="reviews-page">
      <section className="reviews-page-hero">
        <div className="hero-text reviews-hero-title">From our guests</div>
        <img className="fancy-line reviews-fancy-line" src={FancyLine} alt="" />
        <p className="reviews-page-intro">
          For more than three decades, neighbors and travelers alike have
          shared their evenings — and their thoughts — with us. A few of
          their kind words live on these walls.
        </p>
      </section>

      <ReviewDisplayer />

      <section className="reviews-wall-section">
        <div className="reviews-wall-heading">
          <span className="reviews-wall-heading-flourish" aria-hidden="true" />
          <span className="reviews-wall-heading-text">More from the locals</span>
          <span className="reviews-wall-heading-flourish" aria-hidden="true" />
        </div>

        <div className="reviews-grid">
          {reviews.map((r, i) => (
            <motion.article
              key={i}
              className="review-card"
              custom={i}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              variants={cardVariants}
            >
              <span className="review-card-mark" aria-hidden="true">
                &ldquo;
              </span>
              <p className="review-card-text">
                {r.text.replace(/^"|"$/g, "")}
              </p>
              <div className="review-card-attr">— {r.author}</div>
            </motion.article>
          ))}
        </div>
      </section>

      <section className="reviews-cta">
        <img className="super-line reviews-cta-line" src={SuperLine} alt="" />
        <p className="reviews-cta-text">
          Dined with us recently? We'd love to hear about it.
        </p>
        <div className="reviews-cta-buttons">
          <a
            className="reviews-cta-button"
            href="https://www.google.com/maps/search/?api=1&query=Trattoria+Demi+Evanston"
            target="_blank"
            rel="noopener noreferrer"
          >
            Leave a Google review
          </a>
          <a
            className="reviews-cta-button reviews-cta-button-secondary"
            href="https://www.tripadvisor.com/Restaurant_Review-g37479-d435614-Reviews-Trattoria_Demi-Evanston_Illinois.html"
            target="_blank"
            rel="noopener noreferrer"
          >
            Leave a TripAdvisor review
          </a>
        </div>
      </section>
    </div>
  );
}

export default ReviewsPage;
